const products = [
  {
    slug: 'marinated-meats',
    name: 'Marinated Meats',
    image: '/products/marinated meats.png',
    description: 'Pre-marinated, ready to cook: Tandoori, Sheekh Kebab, Chilli Chicken, Lamb Chops, Boti, and more.',
    tag: 'Ready to Cook'
  },
  {
    slug: 'beef',
    name: 'Premium Beef',
    image: '/products/beef.png',
    description: 'Fresh cuts: steaks, ground, roasts, and specialty cuts. Grass-fed and halal-certified.',
    tag: 'Zabiha Halal'
  },
  {
    slug: 'goat',
    name: 'Goat',
    image: '/products/goat.png',
    description: 'Tender Zabiha goat: leg, shoulder, chops, paya, and brain.',
    tag: 'Zabiha Halal'
  },
  {
    slug: 'chicken',
    name: 'Chicken',
    image: '/products/chicken.png',
    description: 'Whole or cut to order. From halal-certified farms.',
    tag: 'Zabiha Halal'
  },
  {
    slug: 'spices',
    name: 'Kerala Spices',
    image: '/products/masala.png',
    description: 'Authentic Kerala spices, single-origin and house blends.',
    tag: 'Premium Quality'
  },
  {
    slug: 'pita',
    name: 'Pita Breads',
    image: '/products/pita breads.png',
    description: 'Soft pita for wraps, dips, or beside a plate of biriyani.',
    tag: 'Daily Fresh'
  },
  {
    slug: 'dates',
    name: 'Premium Dates',
    image: '/products/dates.png',
    description: 'Medjool and other premium varieties, imported direct.',
    tag: 'Import Quality'
  }
];

export default products;
